require('./score-registration.jade')
require('./round-info/round-info.jade')
require('./score-card-info/score-card-info.jade')
require('./select-club/select-club.jade')
require('./select-players/select-players.jade')

# Load Css
require('../../../sass/web/html/_score_input.scss')

require('angular')
require('angular-route')
require("angular-bootstrap")
require('angular-ui-utils')
require('angular-ui-map')
require('../components/flash/flash-module')
require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/auth/auth-module')
require('../components/form/form-module')
require('../components/score-card/score-card-module')
require('../components/error-handler/error-handler-module')
require('../components/remote-api/remote-api-module')
require('../components/payment/payment-module')
require('../components/cache/cache-module')
require('../components/animate/animate-module')
require('../components/map/map-module')
require('../components/analyze-access/analyze-access-module')
require('../components/account/account-module')
require('../components/modal/modal-module')

ScoreRegistrationCtrl = require('./score-registration-controller')
SelectClubCtrl = require('./select-club/select-club-controller')
SelectPlayersCtrl = require('./select-players/select-players-controller')
SelectClubSearchDirective = require('./select-club/search-directive')
SelectClubListDirective = require('./select-club/list-directive')
SelectClubHistoryDirective = require('./select-club/history-directive')
SelectClubSearchService = require('./select-club/select-club-service')
RoundInfoCtrl = require('./round-info/round-info-controller')
RoundInfoService = require('./round-info/round-info-service')
ScoreCardInfoCtrl = require('./score-card-info/score-card-info-controller')
ScoreDataHolderService = require('./score-data-holder-service')
ScoreUploadHelperService = require('./score-upload-helper-service')
AccordionStateHolderService = require('./accordion-state-holder-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-flash'
  'gnp-common-wrapper'
  'gnp-auth'
  'gnp-form'
  'gnp-score-card'
  'gnp-cache'
  'ui.bootstrap'
  'ui.map'
  'gnp-error-handler'
  'gnp-remote-api'
  'gnp-payment'
  'gnp-animate'
  'gnp-map'
  'gnp-analyze-access'
  'gnp-account'
  'gnp-modal'
]
angular.module "gnp-app-score-registration", modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/score-registration/:id?',
        templateUrl: 'web/score-registration/score-registration.jade'
        controller: 'ScoreRegistrationCtrl'
        resolve:
          round: ['RoundAPIService', '$route', (RoundAPIService, $route) ->
            return if not $route.current.params.id
            RoundAPIService.getRound($route.current.params.id)
          ]
          ownerPlayer: ['PlayerAPIService', '$route', (PlayerAPIService, $route) ->
            #don't call service to get owner if round detail navigate to, we can get it in cache
            return if $route.current.params.id
            PlayerAPIService.getOwnerPlayer()
          ]
          fromJapan: ['CountryAPIService', (CountryAPIService) ->
            CountryAPIService.fromJapan()
          ]
        title: '_SCORE_REGISTRATION.TITLE'
        permission:
          signInRequired: true
          paymentRequired: true
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'ScoreRegistrationCtrl', ScoreRegistrationCtrl
  .controller 'SelectClubCtrl', SelectClubCtrl
  .controller 'SelectPlayersCtrl', SelectPlayersCtrl
  .controller 'RoundInfoCtrl', RoundInfoCtrl
  .controller 'ScoreRegistrationScoreCardInfoCtrl', ScoreCardInfoCtrl
  .directive 'gnpSelectClubSearch', SelectClubSearchDirective
  .directive 'gnpSelectClubHistory', SelectClubHistoryDirective
  .directive 'gnpSelectClubList', SelectClubListDirective
  .factory 'SelectClubSearchService', SelectClubSearchService
  .factory 'RoundInfoService', RoundInfoService
  .factory 'ScoreDataHolderService', ScoreDataHolderService
  .factory 'ScoreUploadHelperService', ScoreUploadHelperService
  .factory 'AccordionStateHolderService', AccordionStateHolderService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/score-registration-module.coffee